import React from "react";
import './css/CourseHeaderStyle.css';
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

function HeaderTop() {
    const location = useLocation(); // ✅ React Router hook se location milega

    const titles = {
        "/CSIR-Net-Course": "CSIR NET",
        "/IIT-Gate-Course": "IIT GATE",
        "/IIT-Jam-Course": "IIT JAM", 
        "/TFIR-Course": "TFIR Course",
        "/CUET-PG-Course": "CUET PG Chemistry",
        "/Assistant-professor-Course" : "Assistant Professor",
        "/PGT-Chemistry-Course": "PGT Chemistry",
        "/Geochemist": "UPSC Combined Geoscientist",
    };
    const title = titles[location.pathname] || "My Website";
    return (
            <div className="headerTop">
                <div class="container py-5">
                    <div class="d-flex align-items-center mb-3">
                        <h2 class="fw-bold mb-0">{title}  Previous Year Question Paper PDFs With Solutions (Subject-Wise)</h2>
                    </div>

                    <span class="badge badge-custom mb-3">73+ PYP Tests</span>

                    <p class="mb-3"><i class="bi bi-check2 text-white"></i> <b>73</b> Full Paper PYP (online attempt+pdf)</p>
                    <p class="mb-3">
                        <i class="bi bi-check-circle-fill text-whiet"></i> Also <b>Unlock 35000+ PYP’s</b> with <span class="fw-bold text-white">testbook <span class="badge bg-warning text-dark">PRO</span></span>
                    </p>

                    <div class="mb-4">
                        <Link class="btn btn-green btn-lg me-3">Get Pass Pro Now</Link>
                        <Link class="btn btn-outline-custom btn-lg">Try Free Prev. Year Papers Test</Link>
                    </div>

                    <p class="text-white"><i class="bi bi-people-fill me-1"></i> <b>454.2k</b> Students Improve their score through PYP Tests</p>

                </div>
            </div>
    );
}

export default HeaderTop;